import React from 'react';
import { MdMailOutline, MdPallet, MdSend, MdSwapVerticalCircle } from 'react-icons/md';
import {
  DescArrowForward,
  Loader2,
  MdArrowForward,
  MdChangeCircle,
  MdCheckCircle,
  MdDelete,
  MdDescInsights,
  MdFileDownload,
  MdHandshake,
  MdImage,
  MdInfo,
  MdInventory,
  MdKeyboardArrowDown,
  MdOpenInNew,
  MdOutlineEditNote,
  MdPriceChange,
  MdReport,
  MdSave,
  MdSelectAll,
  MdStore,
  MdUpload,
  Premium,
} from './assets';

export type IconTypes =
  | 'MdPriceChange'
  | 'MdReport'
  | 'MdSelectAll'
  | 'MdKeyboardArrowDown'
  | 'MdOpenInNew'
  | 'MdUpload'
  | 'MdFileDownload'
  | 'MdInfo'
  | 'MdImage'
  | 'MdInventory'
  | 'MdSave'
  | 'MdDelete'
  | 'MdCheckCircle'
  | 'MdStore'
  | 'MdHandshake'
  | 'MdDescInsights'
  | 'DescArrowForward'
  | 'MdOutlineEditNote'
  | 'MdArrowForward'
  | 'MdSwapVerticalCircle'
  | 'MdPallet'
  | 'MdSend'
  | 'MdMailOutline'
  | 'Loader2'
  | 'premium';

type SVGProps = React.SVGProps<SVGSVGElement>;

export type IconProps = {
  icon: IconTypes | React.ReactNode;
} & SVGProps;

const ICONS = {
  MdPriceChange: (props: SVGProps) => <MdPriceChange {...props} />,
  MdReport: (props: SVGProps) => <MdReport {...props} />,
  MdSelectAll: (props: SVGProps) => <MdSelectAll {...props} />,
  MdKeyboardArrowDown: (props: SVGProps) => <MdKeyboardArrowDown {...props} />,
  MdOpenInNew: (props: SVGProps) => <MdOpenInNew {...props} />,
  MdUpload: (props: SVGProps) => <MdUpload {...props} />,
  MdFileDownload: (props: SVGProps) => <MdFileDownload {...props} />,
  MdInfo: (props: SVGProps) => <MdInfo {...props} />,
  MdImage: (props: SVGProps) => <MdImage {...props} />,
  MdInventory: (props: SVGProps) => <MdInventory {...props} />,
  premium: (props: SVGProps) => <Premium {...props} />,
  MdSave: (props: SVGProps) => <MdSave {...props} />,
  MdDelete: (props: SVGProps) => <MdDelete {...props} />,
  MdCheckCircle: (props: SVGProps) => <MdCheckCircle {...props} />,
  MdChangeCircle: (props: SVGProps) => <MdChangeCircle {...props} />,
  MdStore: (props: SVGProps) => <MdStore {...props} />,
  MdHandshake: (props: SVGProps) => <MdHandshake {...props} />,
  MdDescInsights: (props: SVGProps) => <MdDescInsights {...props} />,
  DescArrowForward: (props: SVGProps) => <DescArrowForward {...props} />,
  MdOutlineEditNote: (props: SVGProps) => <MdOutlineEditNote {...props} />,
  MdArrowForward: (props: SVGProps) => <MdArrowForward {...props} />,
  MdSwapVerticalCircle: (props: SVGProps) => <MdSwapVerticalCircle {...props} />,
  MdPallet: (props: SVGProps) => <MdPallet {...props} />,
  MdSend: (props: SVGProps) => <MdSend {...props} />,
  MdMailOutline: (props: SVGProps) => <MdMailOutline {...props} />,
  Loader2: (props: SVGProps) => <Loader2 {...props} />,
} as const;

export const Icon = ({ icon = 'MdSelectAll', ...props }: IconProps) => {
  if (typeof icon !== 'string') return icon;
  const Component = ICONS[icon as IconTypes];

  // Nome fora do registro nao derruba a arvore. O tipo do prop e `IconTypes | React.ReactNode`, e
  // ReactNode inclui string, entao QUALQUER nome passa pelo compilador e um nome errado chega
  // aqui como undefined. Um icone ausente vale um botao sem icone, nunca uma pagina em branco.
  if (!Component) return null;

  return <Component data-testid={`icon-${icon}`} {...props} />;
};
